import update from "immutability-helper";
import type { AnyAction } from "redux";
import type { Group } from "@theirstory/common/api_types/backend";

import { GROUP_ALL_NAMES_LOADED } from "../actions/types";
import type { GroupNamesLoaded } from "../actions/groups";

export interface GroupsState {
  userGroupNames: Group[];
}

const initialState: GroupsState = {
  userGroupNames: [],
};

// groups reducer
const groupsReducer = (state = initialState, { type, payload }: AnyAction) => {
  switch (type) {
    case GROUP_ALL_NAMES_LOADED: {
      return update(state, { userGroupNames: { $set: payload as GroupNamesLoaded } });
    }
    default:
      return state;
  }
};

export default groupsReducer;
